export const TruffleSvgGradientId = "truffle-svg-linear-gradient";
//# sourceMappingURL=consts.js.map